'use strict';

$(document).ready(function () {
    $('body').on('click', '.kitchen-appointment-btn', function (event) {
        event.preventDefault();

        const $this = $(this);
        const modal = $this.closest('.b-actions-container').find('.kitchen-appointment-btn-modal');
        const body = $('body');
        const url = $this.data('url');
        const iframeOrigin = new URL(modal.find('iframe').attr('src')).origin;
        const iframeCloseMessage = $this.data('iframeCloseMessage');

        const closeKitchenIframe = function (e) {
            const iframeEvent = e.originalEvent;

            if (iframeEvent.origin === iframeOrigin && iframeEvent.data === iframeCloseMessage && iframeEvent.source === modal.find('iframe')[0].contentWindow) {
                modal.find('iframe').remove();
                modal.css('display', 'none');
                body.css('overflow', '');
                modal.append(
                    $('<iframe>', {
                        src: url,
                        width: '100%',
                        height: '100%',
                        css: {
                            overflow: 'hidden',
                            border: 'none'
                        }
                    })
                );

                $(window).off('message', closeKitchenIframe);
            }
        };

        modal.css('display', 'block');
        body.css('overflow', 'hidden');

        $(window).on('message', closeKitchenIframe);
    });
});
